import { render, staticRenderFns } from "./PartnerTypeOptions.vue?vue&type=template&id=2979869a"
import script from "./PartnerTypeOptions.vue?vue&type=script&lang=js"
export * from "./PartnerTypeOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports